import { getBaseExpressAppUrl } from '../../../util/config';

/**
 * Represents a single navigation link.
 */
export interface SingleLinkProps {
  /** The title of the link. */
  title: string;
  /** The URL the link points to. */
  to: string;
}

/**
 * Represents a navigation item with sub-links.
 */
export interface MultiLinkProps {
  /** The title of the navigation item. */
  title: string;
  /** The sub-links under the navigation item. */
  links: SingleLinkProps[];
}

/**
 * Default links for the top navigation section.
 */
export const defaultNavSection: SingleLinkProps[] = [
  {
    title: 'Make a Payment',
    to: getBaseExpressAppUrl() + '/portal/express-pay/',
  },
  {
    title: 'Contact Us',
    to: '/contact-us/',
  },
];

/**
 * Default links for the main navigation items.
 */
export const defaultNavItems: MultiLinkProps[] = [
  {
    title: 'Manufactured Home Loans',
    links: [
      {
        title: 'Mortgages & Loans',
        to: '/manufactured-home-loans/',
      },
      {
        title: 'New Manufactured Home Loans',
        to: '/manufactured-home-loans/new-manufactured-home-loan/',
      },
      {
        title: 'Land & Home Loan',
        to: '/manufactured-home-loans/land-home-mortgage/',
      },
      {
        title: 'Less Than Perfect Credit',
        to: '/manufactured-home-loans/less-than-perfect-credit/',
      },
      {
        title: 'Used Home Loan',
        to: '/manufactured-home-loans/used-home-loan/',
      },
      { title: 'Community Lending', to: '/community-lending/' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { title: 'Mortgage Resources', to: '/resources/' },
      { title: 'Home Buying', to: '/resources/home-buying/' },
      { title: 'Home Owning', to: '/resources/home-owning/' },
      { title: 'Payment Options', to: '/resources/payment-options/' },
      { title: 'Documents & Forms', to: '/resources/documents-forms/' },
      { title: 'FAQs', to: '/resources/faqs/' },
      { title: 'Blog', to: '/resources/blog/' },
    ],
  },
  {
    title: 'Mortgage Calculators',
    links: [
      {
        title: 'Mortgage Calculator',
        to: '/calculators/mortgage-calculator/',
      },
      {
        title: 'Early Payoff Calculator',
        to: '/calculators/early-payoff-calculator/',
      },
      {
        title: 'Amortization Calculator',
        to: '/calculators/amortization-calculator/',
      },
      {
        title: 'Extra Monthly Principal Calculator',
        to: '/calculators/extra-monthly-principal/',
      },
      {
        title: 'Biweekly Extra Principal Calculator',
        to: '/calculators/biweekly-extra-principal/',
      },
    ],
  },
  // Pulled out Mobile Home Loan Guide as the page is not ready. See VMFPW-1627
  // {
  //   title: 'Mobile Home Loan Guide',
  //   links: [{ title: 'Mobile Home Loan Guide', to: '/' }],
  // },
];

/**
 * Default links for the sign-in dropdown.
 */
export const defaultSignInLinks: MultiLinkProps[] = [
  {
    title: 'My Account',
    links: [
      { title: 'Sign In', to: getBaseExpressAppUrl() + '/portal/login/' },
      {
        title: 'Make a Payment',
        to: getBaseExpressAppUrl() + '/portal/express-pay/',
      },
      { title: 'Payment Options', to: '/resources/payment-options/' },
      { title: 'Documents & Forms', to: '/resources/documents-forms/' },
    ],
  },
];

/**
 * Default links for the buttons in the header.
 */
export const defaultButtonLinks: SingleLinkProps[] = [
  {
    title: 'Apply Today',
    to: '/applynow/welcome/',
  },
];
